import { render } from "./auditpaniers.vue?vue&type=template&id=0baf40e8&scoped=true"
import script from "./auditpaniers.vue?vue&type=script&lang=js"
export * from "./auditpaniers.vue?vue&type=script&lang=js"

import "./auditpaniers.vue?vue&type=style&index=0&id=0baf40e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baf40e8"]])

export default __exports__